import { createSelector } from '@reduxjs/toolkit';

export default (
  tournaments,
  tournamentStages,
  matches,
  favoriteMatchIds,
  favoriteTournamentIds,
  currentFilter,
) => {
  /**
     * Create "ordered favorites matchIds" selector for an instance of `<FavoritesMenu />`.
     * It collects all favorites matchIds.
     *
     * @return {Immutable.List<number>}
     */

  return createSelector(
    tournaments,
    tournamentStages,
    matches,
    favoriteMatchIds,
    favoriteTournamentIds,
    currentFilter,
    (
      tournamentsById,
      stagesById,
      matchesById,
      favoritesMatchIds,
      favoriteTournamentIds,
      { matchId },
    ) => {
      // filter for a really existing `favoritesMatchIds`
      favoritesMatchIds = favoritesMatchIds.filter((id) => matchesById.has(id));

      // todo: implement ordering for favorites matchIds
      const matchIds = favoriteTournamentIds.reduce((list, tournamentId) => {
        const tournament = tournamentsById.get(tournamentId);

        if (!tournament) {
          return list;
        }

        return stagesById.reduce((list, stage) => {
          if (stage.tournamentId === tournament.id) {
            return list.concat(stage.matchIds);
          }

          return list;
        }, list);
      }, favoritesMatchIds).toList();

      if (!matchId) {
        return matchIds;
      }

      const currentIndex = matchIds.indexOf(matchId);

      if (currentIndex <= 0) {
        return matchIds;
      }

      return matchIds.remove(currentIndex).unshift(matchId);
    },
  );
};
